// 国际化配置
// import zhCN from "@/locale/zh-CN.messages";
// import esES from "@/locale/es-ES.messages";
// import enUS from "@/locale/en-US.messages";

// const localeValue = window.sessionStorage.getItem("locale");
// let messageInfo = null;
// if (localeValue === "zh") {
//   messageInfo = zhCN.publicParam;
// } else if (localeValue === "es") {
//   messageInfo = esES.publicParam;
// } else {
//   messageInfo = enUS.publicParam;
// }

// 设备状态

const stubStruts = () => {
  const strutsMap = [
    {
      text: "全部",
      value: "",
    },
    {
      text: "空闲",
      value: "00",
    },
    {
      text: "充电中",
      value: "01",
    },
    {
      text: "故障",
      value: "02",
    },
    {
      text: "离线",
      value: "05",
    },
    {
      text: "车位占用",
      value: "03",
    },
    {
      text: "维护中",
      value: "04",
    },
    {
      text: "在建中",
      value: "06",
    },
    {
      text: "升级中",
      value: "07",
    },
    {
      text: "预约等待充电中",
      value: "08",
    },
    {
      text: "储能中",
      value: "09",
    },
    {
      text: "离线启动",
      value: "0A",
    },
    {
      text: "插枪空闲",
      value: "0B",
    },
    {
      text: "在线预约中",
      value: "0C",
    },
    {
      text: "锁定状态不允许充电",
      value: "FF",
    },
    {
      text: "充满",
      value: "0D",
    },
    {
      text: "放电中",
      value: "11",
    },
    {
      text: "充电停止",
      value: "21",
    },
    {
      text: "充电暂停",
      value: "22",
    },
    {
      text: "车端预约充电",
      value: "23",
    },
    {
      text: "已鉴权未插枪",
      value: "24",
    },
  ];
  return strutsMap;
};
export default stubStruts;



// WEBPACK FOOTER //
// ./src/AntD/utils/stubStruts.js